class AjaxCartForm extends HTMLElement {
  connectedCallback() {
    this.style.display = 'contents';
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /**
   * @param {Event} event
   */
  async handleSubmit(event) {
    event.preventDefault();
    if (!this.form) return;

    /** @type {HTMLButtonElement | null} */
    const button = this.form.querySelector('[type="submit"]');
    const originalText = button ? button.textContent : '';
    
    if (button) {
      button.disabled = true;
      button.textContent = '...';
    }

    try {
      const formData = new FormData(this.form);

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      /** @type {string[]} */
      const sectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });
      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
      }

      /** @type {any} */
      const theme = typeof Theme !== 'undefined' ? Theme : undefined;
      /** @type {any} */
      const shopify = window.Shopify;
      const cartAddUrl =
        theme?.routes?.cart_add_url || (shopify?.routes?.root ? shopify.routes.root + 'cart/add.js' : '/cart/add.js');

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'text/html',
        },
      });
      const data = await response.json();
      
      if (response.ok) {
        if (button) button.textContent = 'Added';

        let updatedCount = 0;
        if (data?.sections) {
          try {
            const parser = new DOMParser();
            for (const html of Object.values(data.sections)) {
              if (typeof html !== 'string') continue;
              const doc = parser.parseFromString(html, 'text/html');
              const countText = doc.querySelector('[ref="cartItemCount"]')?.textContent;
              if (countText && countText.trim().length) {
                updatedCount = parseInt(countText, 10) || 0;
                break;
              }
            }
          } catch (_) {
            updatedCount = 0;
          }
        }

        if (!updatedCount && shopify?.routes?.root) {
          try {
            const cartResp = await fetch(shopify.routes.root + 'cart.js');
            const cart = await cartResp.json();
            updatedCount = cart.item_count;
          } catch (_) {
            updatedCount = 0;
          }
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { 
            data: { 
              ...data,
              itemCount: updatedCount,
              sections: data?.sections,
              source: 'ajax-cart-form'
            }
          }
        }));

        const cartUrl = theme?.routes?.cart_url || (shopify?.routes?.root ? shopify.routes.root + 'cart' : '/cart');
        const openDrawer = () => {
          /** @type {any} */
          const drawer = document.querySelector('cart-drawer-component');
          if (!drawer) {
            window.location.href = cartUrl;
            return;
          }
          if (typeof drawer.open === 'function') {
            drawer.open();
          } else if (typeof drawer.showDialog === 'function') {
            drawer.showDialog();
          }
        };

        if (customElements.get('cart-drawer-component')) {
          requestAnimationFrame(openDrawer);
        } else {
          customElements.whenDefined('cart-drawer-component').then(() => requestAnimationFrame(openDrawer));
        }
        
        setTimeout(() => {
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
        }, 2000);
      } else {
        console.error('Error adding to cart', data);
        if (button) {
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        }
      }
    } catch (error) {
      console.error('Error:', error);
      if (button) {
        button.textContent = 'Error';
        button.disabled = false;
      }
    }
  }
}

if (!customElements.get('ajax-cart-form')) {
  customElements.define('ajax-cart-form', AjaxCartForm);
}
